module.exports = __webpack_public_path__ + "9ec06ddb2679d01181e22e1660b40e42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003C5E.png
// module id = 1543
// module chunks = 0